import React from 'react';
export function StudioStory() {
  return <section id="story" className="bg-cream pb-20 md:pb-28" data-id="element-182" data-mp="1jn9lf25nwao9">
      <div className="mx-auto max-w-content px-5 md:px-8 lg:px-10" data-id="element-183" data-mp="1f6muvj8dokxf">
        <div className="relative bg-ink px-6 py-16 md:px-16 md:py-24" data-id="element-184" data-mp="10higkd4pf0ul">
          <div className="absolute left-0 top-0 h-full w-[3px] bg-violet" aria-hidden="true" data-id="element-185" data-mp="10fdzsulpi7cw" />
          <p className="text-[11px] font-medium uppercase tracking-[0.22em] text-cream/55" data-id="element-186" data-mp="15guyqkkmrjqu">
            Our story
          </p>

          <figure className="mt-8 max-w-4xl" data-id="element-187" data-mp="1y58wcz7t4e1v">
            <span className="block font-display text-[64px] font-semibold leading-[0.6] text-gold" aria-hidden="true" data-id="element-188" data-mp="1y3xwvble9sgk">
              &ldquo;
            </span>
            <blockquote className="mt-6 font-display text-[26px] font-medium leading-[1.3] tracking-[-0.01em] text-cream md:text-[38px]" data-id="element-189" data-mp="1o5rs8m87e880">
              <p data-id="element-190" data-mp="7v604z0sjjzl">
                I named Black Comet Labs in memory of my black cat. I wanted a little of him to be
                part of what I create next. Today, it&rsquo;s the home for the apps I build&mdash;each
                with its own purpose, all connected by the same care and curiosity.
              </p>
            </blockquote>
            <figcaption className="mt-10 flex items-center gap-4 text-[14px] text-cream/65" data-id="element-191" data-mp="4vmexkpobf6k">
              <span className="h-px w-10 bg-violet" aria-hidden="true" data-id="element-192" data-mp="3w0l2lvbiyoh1" />
              Founder, Black Comet Labs
            </figcaption>
          </figure>
        </div>
      </div>
    </section>;
}